





































































import ModalMixin from '@/mixins/modal.mixin';
import { CrsForm } from '@resclick/crs-ui';
import { compass } from '@resclick/compass';
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { i18n } from '@/i18n';
import { LANGUAGE_MENU } from '@/constants/language-menu.constant';

import { VueEditor } from 'vue2-editor';

@Component({
  components: {
    VueEditor,
  },
})
export default class PoliciesModal extends Mixins(ModalMixin) {
  @Prop() companyId!: string;
  @Prop() policyId!: string;
  activeTab = 'en-US';
  form!: CrsForm<'companies', 'createPolicy' | 'updatePolicy'>;

  get availableLanguages() {
    return LANGUAGE_MENU.map((item) => {
      return {
        label: item.name,
        code: item.iso,
        flag: item.img,
      };
    });
  }

  get documentTypeOptions() {
    return [
      { label: i18n.t('GENERAL.PROPERTY_VOUCHER'), value: 'PROPERTY_VOUCHER' },
      { label: i18n.t('GENERAL.PROPERTY_SALES_AGREEMENT'), value: 'PROPERTY_SALES_AGREEMENT' },
      { label: i18n.t('GENERAL.PROPERTY_CONFIRMATION_FORM'), value: 'PROPERTY_CONFIRMATION_FORM' },
      { label: i18n.t('GENERAL.SALE_CONTRACT'), value: 'SALE_CONTRACT' },
      { label: i18n.t('GENERAL.KVKK'), value: 'KVKK' },
      { label: i18n.t('GENERAL.CANCELLATION_CONDITIONS'), value: 'CANCELLATION_CONDITIONS' },
    ];
  }

  @Watch('mode', { immediate: true })
  switchForm(mode: 'create' | 'update') {
    const formMode = mode === 'create' ? 'createPolicy' : 'updatePolicy';
    this.form = this.$crsForm('companies', formMode, {
      isActive: false,
      type: 'PROPERTY_VOUCHER',
      content: {
        'en-US': '',
        'tr-TR': '',
        'fr-FR': '',
      },
    });
  }

  async getForm() {
    return compass.do('companies', 'findOnePolicy', {
      params: {
        companyId: this.companyId,
        policyId: this.policyId,
      },
      lang: 'all',
    });
  }
}
